<div class="d-flex flex-wrap gap-3 position-relative">
    <div *ngFor="let tag of tags" class="badge-container flex-between align-items-center gap-3 text-small" [style.backgroundColor]="tag.color">
      <div class="badge-name" [ngStyle]="{'color':tagTextColor(tag.color)}">{{tag.name}}</div>
      <div class="badge-remove" (click)="removeTagFromCase(tag)">&times;</div>
    </div>
    <div (click)="showAutocomplete = true;refocus()">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="hero-icon">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
      </svg>
    </div>
    <div class="w-100 position-absolute" style="top: 120%;" *ngIf="showAutocomplete">
      <div class="form-group position-relative">
        <input id="tagSearcher" type="text" class="form-control form-control-sm" placeholder="{{ 'Standard.Search' | translate }}" [(ngModel)]="tagInput" (keyup)="onTagInputChange()" (focus)="onTagInputChange()" (blur)="delayedHide()">
        <div class="autocomplete-items">
          <div *ngFor="let tag of filteredTags" class="autocomplete-item" (click)="addTagToCase(tag)"  
          [innerHTML]="highlightText(tag.name)"></div>
        </div>
      </div>

    </div>
</div>
